import { render } from "./tasks.vue?vue&type=template&id=3b27f200"
import script from "./tasks.vue?vue&type=script&lang=js"
export * from "./tasks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__